export default "__VITE_ASSET__D0hWS$wY__"